<template lang="pug">
StandardChart(:input="chartData", v-if="summary")
</template>

<script>
import _ from "underscore";
export default {
  props: ["summary"],
  computed: {
    chartData() {
      if (!this.summary) return null;
      const months = _.map(
        this.summary,
        (o) => String(Math.round(o.month / 100)) + "/" + String(o.month % 100)
      );
      const data = {
        title: "Visit",
        labels: months,
        values: _.pluck(this.summary, "visit"),
        isCurrency: false,
      };
      return data;
    },
  },
};
</script>